import {useCallback, useState} from "react";
import {set} from "lodash";

export const useFormStateHook = rules => {
    const [formValues, setFormValues] = useState({});

    const onFormValueChange = useCallback((field, val, validator = null) => {
        setFormValues(currentFormValues => set({...currentFormValues}, field, val));

        if (validator) {
            const errorMessage = validator(val);
            setFormValues(currentFormValues => {
                return set({...currentFormValues}, `errors.${field}`, errorMessage ?? null);
            });
        }
    }, []);

    return {formValues, onFormValueChange};
};
